import { Button } from '@ps/sports-ui-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import { TXTWCL_Login_to_bet } from './LoginButton.messages.json';

const LoginButton: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { buttonPressed } = useTrackers();
  const buttonName = useTrackingLabel(TXTWCL_Login_to_bet);

  return (
    <Button
      onClick={() => {
        buttonPressed({ buttonName });
        modal.enqueue({ path: '/auth/login' });
      }}
    >
      <Translation {...TXTWCL_Login_to_bet} />
    </Button>
  );
};

export default LoginButton;
